import { TRANSLATIONS } from "@versedrill/core";
import { useVersions } from "@/lib/useVersions.ts";
import { cn } from "@/lib/utils";

/** The credit for the version on screen. The publishers of the licensed versions require it wherever their text appears. */
export function ScriptureNotice({ className }: { className?: string }) {
  const { current } = useVersions();
  return <p className={cn("font-ui text-[0.7rem] leading-snug text-muted-foreground", className)}>{TRANSLATIONS[current].notice}</p>;
}
